import PreviewSvg from "./PreviewSvg";
import CommentsSvg from "./CommentsSvg";
import InfoSvg from "./InfoSvg";
import DownloadSvg from "./DownloadSvg";
import UnreadSvg from "./UnreadSvg";
import AdmissionForwardSvg from "./AdmissionForwardSvg";
import TasksSvg from "./TasksSvg";
import MoveSvg from "./MoveSvg";
import DeleteSvg from "./DeleteSvg";
import CloseSvg from "./CloseSvg";
import UnknownUserSvg from "./UnknownUserSvg";
import StatusRedSvg from "./StatusRedSvg";
import EditorOkSvg from "./EditorOkSvg";
import EditorCloseSvg from "./EditorCloseSvg";

export const applicationPageSvgConst = {
  PreviewSvg,
  CommentsSvg,
  InfoSvg,
  DownloadSvg,
  UnreadSvg,
  AdmissionForwardSvg,
  TasksSvg,
  MoveSvg,
  DeleteSvg,
  CloseSvg,
  UnknownUserSvg,
  StatusRedSvg,
  EditorOkSvg,
  EditorCloseSvg,
};
